import { InputValidity } from '@one/web-components';
import { PopupExtendedContextType } from 'core/contexts/popup-extended.context';
import { GraphqlError } from './backend-service';

export const handleErrorPopupContext = (errors: GraphqlError[], context: PopupExtendedContextType) => {
    context.setData('SET_DATA', {
        ...context.data,
        filterSaveErrors: errors,
    });
    const backendErrors = errors.reduce(
        (result, e) => {
            const fieldArray = e.extensions?.field?.split('.');
            const field = fieldArray?.at(-1);
            if (field) {
                result[field] = { state: 'error', type: ['custom'] };
            }
            return result;
        },
        {} as Record<string, InputValidity>
    );
    context.setData('SET_DATA', {
        ...context.data,
        filterSaveValidity: {
            ...context.data.filterSaveValidity,
            ...backendErrors,
        },
        filterSaveErrors: errors,
    });
};
